import * as React from "react";
import Icon from "baseui/icon/icon";
import omitDollarPrefixedKeys from "baseui/icon/omit-dollar-prefixed-keys.js";
import { IconProps } from "baseui/icon";
import { mergeOverride, toObjectOverride } from "baseui/helpers/overrides.js";
import { useStyletron } from "kanopi-components/theme/useStyletron";

function LightBulb(props: IconProps, ref) {
  const [, theme] = useStyletron();
  const { overrides = {}, ...restProps } = props;
  const SvgOverride = mergeOverride(
    // Icons from theme really targets the SVG override in the underlying Icon component, but
    // have props typed with IconPropsT. Provided the missing props inline below here.
    {
      component: theme.icons && theme.icons.LightBulb ? theme.icons.LightBulb : null,
      props: {
        title: "Light Bulb",
        viewBox: "0 0 25 30",
        ...omitDollarPrefixedKeys(restProps),
      },
    },
    overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {}
  );
  return (
    <Icon viewBox="0 0 25 30" ref={ref} overrides={{ Svg: SvgOverride }} {...restProps}>
      <path
        opacity=".5"
        d="M19.885 8.294A8.5 8.5 0 004 12.5a8.52 8.52 0 004.263 7.368c.458.267.739.758.737 1.288V27a.5.5 0 00.5.5h.5a2.5 2.5 0 005 0h.5a.5.5 0 00.5-.5v-5.842a1.45 1.45 0 01.705-1.272 8.5 8.5 0 003.18-11.592zM12.5 29a1.5 1.5 0 01-1.5-1.5h3a1.5 1.5 0 01-1.5 1.5zm2.5-2.5h-5v-.982c.96-.006 3.22 0 5 .008v.974zm0-1.974c-2.85-.013-4.271-.018-5 0V23.5h5v1.026zm0-2.026h-5v-1.013l5 .013v1zm1.21-3.483a2.41 2.41 0 00-1.124 1.483l-5.179-.012A2.476 2.476 0 008.761 19 7.516 7.516 0 015 12.5a7.5 7.5 0 1111.21 6.517zM3.729 7.069l-.007-.004-1.902-1c-.263-.136-.598-.052-.748.188-.149.238-.06.54.2.678l1.901 1c.262.14.598.06.752-.178.153-.238.065-.545-.196-.684zM3.928 17.253c-.15-.24-.483-.324-.746-.188l-.007.004-1.898.998c-.263.136-.355.44-.205.68.15.24.484.324.746.188l.007-.004 1.898-.998c.263-.136.355-.44.205-.68zM23.73 18.07c-.003 0-.005-.002-.007-.003l-1.898-.998c-.261-.14-.597-.06-.75.178-.153.238-.065.543.196.683l.006.003 1.898.998c.261.14.597.06.75-.178.153-.238.065-.543-.196-.683zM23.928 6.253c-.15-.24-.484-.324-.748-.188a.272.272 0 00-.006.004l-1.9.999c-.262.138-.352.443-.2.682a.586.586 0 00.75.183l1.899-1c.263-.135.355-.44.205-.68zM18.747 1.072c-.238-.149-.54-.06-.68.2l-1 1.904c-.138.262-.056.599.183.75.24.152.546.062.684-.2l1-1.905c.137-.264.053-.6-.187-.75z"
        fill="#232322"
      />
      <path
        opacity=".5"
        d="M12.5 0a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zM7.935 3.18l-.004-.007-1-1.902c-.14-.261-.446-.349-.684-.196-.236.152-.317.484-.182.745l1 1.902c.137.264.442.356.682.206.24-.15.324-.485.188-.748zM2.5 12h-2a.5.5 0 000 1h2a.5.5 0 000-1zM24.5 12h-2a.5.5 0 000 1h2a.5.5 0 000-1zM16.86 10.154a.443.443 0 00-.67 0l-5.036 5.577-2.35-2.603a.443.443 0 00-.67.013.567.567 0 000 .73l2.685 2.975a.443.443 0 00.671 0l5.37-5.948a.567.567 0 000-.744z"
        fill="#232322"
      />
    </Icon>
  );
}

export default React.forwardRef<IconProps, mixed>(LightBulb);
